import { render, staticRenderFns } from "./TaxCodeInfoList.vue?vue&type=template&id=459c23e2"
import script from "./TaxCodeInfoList.vue?vue&type=script&lang=js"
export * from "./TaxCodeInfoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports